import React from 'react'
import PropTypes from 'prop-types'

export const CloseIcon = ({ width = 18, height = 18, type = 'bold', invert, className, onClick }) => {
	const color = invert ? '#ffffff' : '#566B76'

	if (type === 'bold') {
		return (
			<svg
				width={width}
				height={height}
				viewBox="0 0 18 18"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
				onClick={onClick}
			>
				<path
					d="M17.4853 16.0711C17.8757 16.4614 17.8764 17.0942 17.4853 17.4853C17.095 17.8756 16.4614 17.8756 16.0711 17.4853L9.00006 10.4142L1.92828 17.486C1.53725 17.8756 0.904392 17.8749 0.514069 17.4846L0.513362 17.4839C0.123746 17.0928 0.124453 16.46 0.515484 16.0703L7.59292 9.00706L0.514776 1.92892C0.123746 1.53789 0.124453 0.905031 0.514776 0.514708C0.905806 0.123678 1.53796 0.123678 1.92899 0.514708L9.00854 7.59426L16.0874 0.529557C16.4777 0.139234 17.1099 0.139234 17.5009 0.530264C17.8912 0.920587 17.8757 1.5386 17.4846 1.92963L10.4143 8.99999L17.4853 16.0711Z"
					fill={color}
				/>
			</svg>
		)
	}
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			onClick={onClick}
		>
			<path
				d="M9.73776 8.99991L17.4852 16.7473C17.6889 16.9511 17.6889 17.2814 17.4852 17.4852C17.2814 17.6889 16.9511 17.6889 16.7473 17.4852L8.99991 9.73776L1.25248 17.4852C1.04873 17.6889 0.718382 17.6889 0.51463 17.4852C0.310878 17.2814 0.310878 16.9511 0.51463 16.7473L8.26206 8.99991L0.51463 1.25248C0.310878 1.04873 0.310878 0.718382 0.51463 0.51463C0.718382 0.310878 1.04873 0.310878 1.25248 0.51463L8.99991 8.26206L16.7473 0.51463C16.9511 0.310878 17.2814 0.310878 17.4852 0.51463C17.6889 0.718382 17.6889 1.04873 17.4852 1.25248L9.73776 8.99991Z"
				fill={color}
			/>
		</svg>
	)
}

CloseIcon.propTypes = {
	type: PropTypes.oneOf(['bold', 'light']),
	invert: PropTypes.bool,
	onClick: PropTypes.func,
}
